<div *ngIf="keyValid" style="display: none;">
    {{ "START_TABLE_COLUMN_SORTING_KEY_" + key + "_END_TABLE_COLUMN_SORTING_KEY" }}
</div>
